import { DrawerBackdrop, DrawerCloseTrigger, DrawerContent, DrawerHeader, DrawerPositioner, DrawerRoot, DrawerTitle, Portal } from "@chakra-ui/react"

export default function Drawer({ title, loading = false, children, onClose = () => {}, ...props }){
    return(
    <DrawerRoot onInteractOutside={onClose} onEscapeKeyDown={onClose} closeOnInteractOutside={!loading} {...props}>
        <Portal>
            <DrawerBackdrop />
            <DrawerPositioner>
                <DrawerContent>
                    <DrawerCloseTrigger />
                    <DrawerHeader>
                        <DrawerTitle children={title} />
                    </DrawerHeader>
                    {children}
                </DrawerContent>
            </DrawerPositioner>
        </Portal>
      </DrawerRoot>
    )
}